import { useCallback, useMemo } from 'react';
import useUser from '@alltrails/context/hooks/useUser';
import { isCompleted } from '@alltrails/lists/utils/listUtils';
import { type ListsState, toggleListItem } from '@alltrails/lists/slices/lists';
import type { TrailId } from '@alltrails/types/TrailId';
import { useAppDispatch, useAppSelector } from '../redux';

const MAGIC_ID_COMPLETED = 1001;

const useTrailCompleted = (trailId: TrailId) => {
  const dispatch = useAppDispatch();
  const user = useUser();
  const listItems = useAppSelector((state: { lists: ListsState }) => state.lists.listItems);

  const completed = useMemo(() => isCompleted(listItems, 'trail', trailId), [listItems, trailId]);

  const toggleTrailCompleted = useCallback(() => {
    if (!user) {
      return;
    }

    dispatch(
      toggleListItem({
        userId: user.id,
        listId: MAGIC_ID_COMPLETED,
        type: 'trail',
        objectId: trailId
      })
    );
  }, [user, dispatch, trailId]);

  return { completed, toggleTrailCompleted };
};

export default useTrailCompleted;
